import React, { useEffect, useState } from "react";
import {
  Box, Typography, Paper, Grid, CircularProgress, Snackbar, Alert
} from "@mui/material";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, LabelList
} from "recharts";
import axios from "../../utils/axios"; // axios đã có sẵn baseURL = http://.../api

import ShortenForm from '../../components/ShortenForm';
import BulkShortenForm from './BulkShortenForm';

export default function DashboardHome() {
  const [data, setData] = useState(null);              // Thống kê tổng quan
  const [chartData, setChartData] = useState([]);      // Dữ liệu biểu đồ click/ngày
  const [snack, setSnack] = useState({
    open: false,
    text: "",
    severity: "success"
  });
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    console.log("Base URL axios:", axios.defaults.baseURL);
    setLoading(true);

    // Gọi API thống kê tổng quan cho admin
    axios.get('/statistics/admin', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setData(res.data))
      .catch(() => setSnack({
        open: true,
        text: "Lỗi tải thống kê tổng quan!",
        severity: "error"
      }))
      .finally(() => setLoading(false));

    // Gọi API lấy dữ liệu biểu đồ click/ngày
    axios.get('/statistics/admin/stats', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setChartData(res.data.chart || []))
      .catch(() => setSnack({
        open: true,
        text: "Lỗi tải biểu đồ click!",
        severity: "error"
      }));

  }, [token]);

  return (
    <Box>
      <Typography variant="h5" fontWeight={800} sx={{ mb: 3 }}>
        Thống kê tổng quan
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 3, textAlign: "center", bgcolor: "#e0f2fe" }}>
              <Typography fontWeight={700} fontSize={18}>Tổng link</Typography>
              <Typography color="primary" fontWeight={900} fontSize={34}>
                {data?.totalLinks ?? "--"}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 3, textAlign: "center", bgcolor: "#fef9c3" }}>
              <Typography fontWeight={700} fontSize={18}>Tổng user</Typography>
              <Typography color="primary" fontWeight={900} fontSize={34}>
                {data?.totalUsers ?? "--"}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 3, textAlign: "center", bgcolor: "#bbf7d0" }}>
              <Typography fontWeight={700} fontSize={18}>Tổng click</Typography>
              <Typography color="primary" fontWeight={900} fontSize={34}>
                {data?.totalClicks ?? "--"}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 3, textAlign: "center", bgcolor: "#e0e7ef" }}>
              <Typography fontWeight={700} fontSize={18}>Link active</Typography>
              <Typography color="primary" fontWeight={900} fontSize={34}>
                {data?.activeLinks ?? "--"}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 3, textAlign: "center", bgcolor: "#fce7f3" }}>
              <Typography fontWeight={700} fontSize={18}>Click hôm nay</Typography>
              <Typography color="primary" fontWeight={900} fontSize={34}>
                {data?.todayClicks ?? "--"}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      )}

      <Typography fontWeight={700} fontSize={19} sx={{ mb: 1 }}>
        Biểu đồ click/ngày
      </Typography>
      <Paper sx={{ p: 3, mb: 5 }}>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" fontSize={13} />
            <YAxis fontSize={13} />
            <Tooltip />
            <Bar dataKey="clicks" fill="#6366f1">
              <LabelList dataKey="clicks" position="top" fontSize={12} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Paper>

      <Box sx={{ mt: 4 }}>
        <Typography fontWeight={700} fontSize={19} sx={{ mb: 2 }}>
          Rút gọn link nhanh
        </Typography>
        <Box sx={{ maxWidth: 600 }}>
          <ShortenForm token={token} />
        </Box>
      </Box>

      <BulkShortenForm onSuccess={(links) => {
        console.log("Links đã tạo:", links);
      }} />

      <Snackbar
        open={snack.open}
        autoHideDuration={2500}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert severity={snack.severity} sx={{ width: "100%" }}>
          {snack.text}
        </Alert>
      </Snackbar>
    </Box>
  );
}
